import { render, staticRenderFns } from "./NewProjectResourcesList.vue?vue&type=template&id=683f2b52&scoped=true"
import script from "./NewProjectResourcesList.vue?vue&type=script&lang=js"
export * from "./NewProjectResourcesList.vue?vue&type=script&lang=js"
import style0 from "./NewProjectResourcesList.vue?vue&type=style&index=0&id=683f2b52&prod&lang=scss"
import style1 from "./NewProjectResourcesList.vue?vue&type=style&index=1&id=683f2b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f2b52",
  null
  
)

export default component.exports